import styled from 'styled-components';
import { Container } from '$app/shared/components/Container';

export default styled(Container)`
  >.garages {
    padding: 20px 0;
    >.line {
      border-top: 1px solid #d4dce8;
      margin-top: 15px;
      margin-bottom: 20px;
    }
    .ant-checkbox-wrapper, .default-checked {
      color: #394047;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
    }

    >.ant-checkbox-wrapper {
      margin-right: 40px;
      >.ant-checkbox-indeterminate .ant-checkbox-inner::after {
        background-color: #ffffff;
      }
    }
    >.ant-switch {
      margin-right: 10px;
    }
    >.group {
      > label {
        width: 30%;
        padding-bottom: 15px;
        margin-left: 0px;
      }
    }
    >.ant-btn {
      font-size: 14px;
      color: #ffffff;
      background: #1890ff;
      border-radius: 4px;
      height: 40px;
      width: 64px;
      margin-top: 20px;
    }
  }
  .errors {
    color: #a94442;
    margin-bottom: 20px;
    border: 1px solid #ebccd1;
    border-radius: 4px;
    > div:nth-child(1) {
      font-size: 16px;
      font-weight: 600;
      padding: 10px 15px;
      background-color: #f2dede;
      border-bottom: 1px solid #ebccd1;
    }
    > div:nth-child(2) {
      font-size: 14px;
      padding: 10px 15px;
      background-color: #fff;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
`;